import { ThemeProvider } from '@emotion/react';
import { I18nProvider } from '@lingui/react';
import AppRouter from 'modules/navigation/router';
import RouteAdapter from 'modules/navigation/utils/route-adapter';
// global styles start
import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.scss';
import React from 'react';
// global styles end
import { Provider } from 'react-redux';
import { Slide, ToastContainer } from 'react-toastify';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { i18n } from 'shared/i18n';
import { history, store } from 'store/store';
import { theme } from 'styles/theme/theme';
import { QueryParamProvider } from 'use-query-params';

// Язык активирует `src/index.tsx` до первого рендера, там же — локаль react-datepicker (`shared/i18n`).
const App = React.memo(function App() {
  return (
    <ThemeProvider theme={theme}>
      <I18nProvider i18n={i18n}>
        <Provider store={store}>
          <Router history={history}>
            <QueryParamProvider ReactRouterRoute={RouteAdapter}>
              <AppRouter />
            </QueryParamProvider>
            {/*
              Контейнер тостов — внутри роутера: тост со ссылкой (`<Link>`) без контекста роутера
              падает при рендере, а ErrorBoundary нет — размонтировалось всё приложение (IMGM-1507).
              limit=2: третий тост мгновенно вытесняет первый, а не копится поверх него.
            */}
            <ToastContainer autoClose={3000} theme="colored" transition={Slide} limit={2} />
          </Router>
        </Provider>
      </I18nProvider>
    </ThemeProvider>
  );
});

export default App;
